<div class="component-container mat-typography mat-body mat-app-background">
  <mat-accordion>

    @if (retrievedInfo && someAppsPending) {
      @for (app of retrievedInfo.searchedApplications; track trackByAppId($index, app)) {
        @if (app.portalApplicationStatus === 'IN_PROGRESS') {
          <mat-expansion-panel (click)="getAppData(app.applicationTrackingId)">
            <mat-expansion-panel-header [expandedHeight]="'60px'" [collapsedHeight]="'60px'">
              <mat-panel-title>
                <div>{{app.productDescription}}</div>
                <div>{{app.applicationTrackingId}}</div>
                <div>{{app.combinedStatus}}</div>
              </mat-panel-title>
            </mat-expansion-panel-header>
            <section class="panel-content">
              <div class="give-me-some-space around section-1">
                <div class="header-and-print">
                  <div class="header"><h2>Product Information</h2></div>
                </div>
                <div class="app-info-and-member-services">
                  <section class="app-info">
                    <div class="content-row">
                      {{app.productDescription}}
                    </div>
                    <div class="content-row">
                      @if (app.premium) {
                        Premium: {{ app.premium | currency }}
                      } @else {
                        <mat-progress-spinner [diameter]="36"></mat-progress-spinner>
                      }
                    </div>
                    <div class="content-row">
                      @if (app.premium) {
                        <a href="javascript:void(0)" (click)="goToPlanDetails(app.planId)">View Plan Details</a>
                      } @else {
                        <mat-progress-spinner [diameter]="36"></mat-progress-spinner>
                      }
                    </div>
                    <div class="content-row">
                      <button mat-raised-button color="primary" (click)="continueEnrollment(app.applicationTrackingId)">Continue Your Enrollment...</button>
                    </div>
                  </section>
                  <section class="member-info-container">
                    @if (content.appSubmittedContentOne) {
                      <div class="member-info">
                        <span>{{content.appSubmittedContentOne}}</span>
                      </div>
                    }
                  </section>
                </div>
              </div>
              @if (content.appSubmittedContentTwo) {
                <div class="give-me-some-space above around important-info-section">
                  <span>{{content.appSubmittedContentTwo}}</span>
                </div>
              }
            </section>
          </mat-expansion-panel>
        }
      }
    } @else {
      <div class="no-data">
        <span>No Plans Submitted/Saved</span>
      </div>
    }
  </mat-accordion>
</div>
